const PASSWORD_STORAGE_KEY = "epico_access_password";

export function getStoredPassword(): string | null {
  return localStorage.getItem(PASSWORD_STORAGE_KEY);
}

export function setStoredPassword(password: string): void {
  localStorage.setItem(PASSWORD_STORAGE_KEY, password);
}

export function clearStoredPassword(): void {
  localStorage.removeItem(PASSWORD_STORAGE_KEY);
}
